import { FC, useEffect } from "react";
import { RouteObject, useRoutes, useLocation, Navigate } from 'react-router-dom'
import Home from '@/pages/home'
import Company from "@/pages/company";
import ContactUs from "@/pages/contact-us";

// Articles were moved out of the hash router to real paths (/articles/:id).
// Keep old hash links (域名/#/blog/xxx) working by redirecting them to the
// corresponding real articles path with a full page load.
const LegacyBlogRedirect: FC = () => {
  const location = useLocation();
  useEffect(() => {
    // /blog -> /articles/，/blog/:id -> /articles/:id/（文章页统一带尾斜杠）
    let path = location.pathname.replace(/^\/blog/, "/articles");
    if (!path.endsWith("/")) path += "/";
    window.location.assign(path + location.search);
  }, [location]);
  return null;
};

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
    children: [
      {
        path: "/e-commerce-marketplace",
        element: <></>,
      },
      {
        path: "/influencer-publisher",
        element: <></>,
      },
      {
        path: "/drop-shipping-merchant",
        element: <></>,
      },
      {
        path: "/ai-shopping-agent",
        element: <></>,
      },
      {
        path: "/merchants-brands",
        element: <></>,
      },
      {
        path: "/brand-launch",
        element: <></>,
      },
      {
        path: "/shopgeni",
        element: <></>,
      },
      {
        path: "/price-hunter",
        element: <></>,
      },
      {
        path: "/geo",
        element: <></>,
      },
    ],
  },
  {
    path: "/company",
    element: <Company />,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
  },
  {
    path: "/blog",
    element: <LegacyBlogRedirect />,
  },
  {
    path: "/blog/:id",
    element: <LegacyBlogRedirect />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

const Router: FC = () => {
  return useRoutes(routes);
};

export default Router;
